type Variant = "light" | "dark";

const UC_SIGILL_LIGHT = "https://www.uc.se/ucsigill2/sigill?org=5569148306&language=swe&product=lsa&fontcolor=b&type=svg";
const UC_SIGILL_DARK = "https://www.uc.se/ucsigill2/sigill?org=5569148306&language=swe&product=lsa&fontcolor=w&type=svg";
const UC_LINK = "https://www.uc.se/risksigill2?showorg=5569148306&language=swe";

const DNB_SIGILL = "https://ratinglogo.bisnode.com/274555-1694984747442426713.svg";
const DNB_LINK = "https://www.dnb.com/sv-se/om-oss/kreditvarderingsmodell-foretag/";

interface Props {
  variant?: Variant;
  className?: string;
  showLabel?: boolean;
  showStats?: boolean;
}

export function CreditSeals({ variant = "light", className = "", showLabel = true, showStats = false }: Props) {
  const isDark = variant === "dark";
  const ucSrc = isDark ? UC_SIGILL_DARK : UC_SIGILL_LIGHT;
  const labelColor = isDark ? "text-cream/80" : "text-muted-foreground";
  const bg = isDark ? "" : "bg-white";
  const border = isDark ? "border-white/10" : "border-border";

  return (
    <div className={`w-full ${bg} border-y ${border} ${className}`}>
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-4 text-center">
        <div className="inline-flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
          {showLabel && (
            <span className={`flex h-14 items-center text-[0.65rem] md:text-xs uppercase tracking-[0.2em] ${labelColor} font-medium whitespace-nowrap leading-none`}>
              Verifierad & kreditvärdig
            </span>
          )}
          <div className="flex items-center gap-6 md:gap-10">
            <a
              href={UC_LINK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="UC Risksigill – BBN Nordic AB"
              className="flex h-14 items-center hover:opacity-80 transition-opacity"
            >
              <img src={ucSrc} alt="UC Sigill – BBN Nordic AB" width={248} height={56} loading="lazy" decoding="async" className="h-14 w-auto" />
            </a>
            <a
              href={DNB_LINK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Dun & Bradstreet kreditvärdighetssigill"
              className="flex h-14 items-center hover:opacity-80 transition-opacity"
            >
              <img src={DNB_SIGILL} alt="Dun & Bradstreet kreditvärdighetssigill" width={120} height={48} loading="lazy" decoding="async" className="h-10 md:h-12 w-auto" />
            </a>
          </div>
        </div>
      </div>

      {showStats && (
        <div className="border-t border-border/60 bg-muted/40">
          <div className="mx-auto max-w-7xl px-5 md:px-10 py-2.5 text-center">
            <p className="text-[0.7rem] sm:text-xs font-semibold tracking-[0.15em] uppercase text-navy">
              3 500+ nöjda kunder · verksamma i Sverige sedan 2008 · 10 års garanti
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
